import { FeedItemActivityDTO } from '../dtos/FeedItemActivity.dto';
import {
  ActivityLogType,
  FeedItemActivityLogModel,
} from '../models/FeedItemActivityLog.model';

export class FeedItemActivityLogUtils {
  public static mapToViewModel(
    dto: FeedItemActivityDTO,
  ): FeedItemActivityLogModel {
    return {
      email: dto.loggedBy.email,
      fullName: this.getFullName(dto),
      loggedOn: dto.logDate,
      type: this.getActivityType(dto),
    };
  }

  private static getActivityType(dto: FeedItemActivityDTO): ActivityLogType {
    return dto.type === 'NOTIFICATION' ? 'Conversion' : 'View';
  }

  private static getFullName(dto: FeedItemActivityDTO): string {
    return `${dto.loggedBy.firstName} ${dto.loggedBy.lastName}`;
  }
}
